/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var bodybuilder = require('bodybuilder');
var Ladda = require('ladda');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');

var StringCell = require('common/backgrid/StringCell');
var ButtonLinkCell = require('common/backgrid/ButtonLinkCell');

var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');
var toHash = require('common/util/toHash');
var SearchCOCContacts = require('../services/SearchCOCContacts');
var COCInternalSidebarNavView = require('../views/COCInternalSidebarNavView');

require('../styles/COCContactSearchView.css');
var tmplCOCContactSearchView = require('../templates/COCContactSearchView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCContactSearchView,

  className: 'coc-contact-search-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    newContact: '.btn-new-contact',
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    clearFilters: '.clear-filters',
    formInputs: ':input'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'click @ui.clearFilters': 'onClickClearFilters',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  templateHelpers: function() {},

  initialize: function() {
    this.lookupHashes = {
      charterTypes: toHash(this.model.get('charterTypes'), 'id', 'type'),
      corporateStructures: toHash(this.model.get('corporateStructures'), 'id', 'type'),
      federalRegulators: toHash(this.model.get('federalRegulators'), 'id', 'regulator'),
      ownershipStructures: toHash(this.model.get('ownershipStructures'), 'id', 'structure'),
      statuses: toHash(this.model.get('statuses'), 'id', 'status'),
      entityTypes: toHash(this.model.get('entityTypes'), 'id', 'type')
    };
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new COCInternalSidebarNavView());

    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResults = new GridView({
      columns: [
        {
          name: 'contactName',
          label: 'Contact Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'contactPhone',
          label: 'Contact Phone',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'contactEmail',
          label: 'Contact Email',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: 'contactEntities',
          label: 'Entity Names',
          cell: StringCell,
          headerCell: 'custom',
          width: 10,
          editable: false
        },
        {
          name: '',
          label: '',
          cell: ButtonLinkCell.extend({
            name: 'Open',
            newTab: true,
            buttonClass: 'btn-primary btn-sm',
            href: function(model) {
              return '#coc/contact/' + model.get('contactId') + '/dashboard';
            }
          }),
          headerCell: 'custom',
          width: 5,
          sortable: false,
          editable: false
        }
      ],
      collection: new PageableCollection([], { pageSize: 25 }),
      emptyText: 'No Contacts Found'
    });

    this.showChildView('searchResultsContainer', this.searchResults);

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function() {
    var self = this;
    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });
    // If no inputs were given, do not perform a search.
    if (!data.contactName && !data.contactPhone && !data.contactEmail && !data.entityName) {
      return;
    }
    this.searchSummaryView.reset();

    var l = Ladda.create(this.ui.search[0]);
    l.start();
    var body = bodybuilder();

    if (data.contactName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'contactName', {
          query: data.contactName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'contactName', data.contactName.toLowerCase() + '*');
        b.orQuery('match', 'contactName.phonetic', data.contactName);
        return b;
      });
    }

    if (data.contactPhone) {
      body.query('wildcard', 'contactPhone', data.contactPhone + '*');
    }

    if (data.contactEmail) {
      body.query('bool', function(b) {
        b.orQuery('match', 'contactEmail', {
          query: data.contactEmail,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'contactEmail', data.contactEmail.toLowerCase() + '*');
        b.orQuery('match', 'contactEmail.phonetic', data.contactEmail);
        return b;
      });
    }

    if (data.entityName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'contactEntities', {
          query: data.entityName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'contactEntities', data.entityName.toLowerCase() + '*');
        b.orQuery('match', 'contactEntities.phonetic', data.entityName);
        return b;
      });
    }

    body.size(this.model.get('searchLimit'));
    var bodyObj = body.build();
    // Keep for testing
    // console.log(JSON.stringify(bodyObj, null, 2));
    // console.log('formData:', data);
    SearchCOCContacts(bodyObj)
      .done(function(data) {
        l.stop();
        self.searchResults.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickClearFilters: function() {
    this.ui.formInputs.val('');
  }
});
